<template>
  <div class="container mt-4">
    <h1 class="mb-3 text-center">Contratos Sociais</h1>

    <b-card>
      <b-table
        :items="pdfs"
        :fields="fields"
        bordered
        hover
        responsive
        empty-text="Nenhum PDF encontrado"
      >
        <template #cell(file_name)="data">
          <i class="fas fa-file text-black mr-2"></i>
          <strong>{{ data.item.file_name }}</strong>
        </template>

        <template #cell(representative)="data">
          <span v-html="data.item.representative.replace(/, /g, '<br>')"></span>
        </template>

        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            :href="data.item.file"
            target="_blank"
          >
            Abrir
          </b-button>

          <b-button
            size="sm"
            variant="success"
            :href="data.item.file"
            download
          >
            Baixar
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { 
  BTable,
  BButton,
  BCard,
  BIcon
} from 'bootstrap-vue'

export default {

  components: {
    BTable,
    BButton,
    BCard,
    BIcon
  },

  data() {
    return {
      fields: [
        { key: 'file_name', label: 'Nome do Arquivo', thClass: 'text-center' },
        { key: 'representative', label: 'Representante', thClass: 'text-center' },
        { key: 'actions', label: 'Ações', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'last_updated_at', label: 'Última atualização', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'updated_by', label: 'Atualizado por', thClass: 'text-center', tdClass: 'text-center' },
      ],
      pdfs: [
        {
          file_name: 'Contrato social Via Invest Securitizadora',
          representative: 'Luiz Carlos Casante, Wagner Castilho Rodrigues Fernandes',
          file: '/pdfs/jucesp Via Sec (1ª alteração).pdf',
          last_updated_at: '17/07/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social Via Invest Participações',
          representative: 'Luiz Carlos Casante (Isolado)',
          file: '/pdfs/Jucesp Via Participações.pdf',
          last_updated_at: '02/03/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social Via Invest Gestão',
          representative: 'Diogo Dourado Favero, Karen Luisa Ferreira',
          file: '/pdfs/VIA GESTÃO CONTRATO SOCIAL.pdf',
          last_updated_at: '27/04/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social SoulPay',
          representative: 'Luiz Carlos Casante, Paulo Marcelo de Castro',
          file: '/pdfs/CONTRATO SOCIAL - REGISTRADO.pdf',
          last_updated_at: '18/09/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social Via Invest Consultoria',
          representative: 'Luiz Carlos Casante, Raquel Amaya Aguiar Rodrigues Fernandes',
          file: '/pdfs/Jucesp - Junta Comercial do Estado de São Paulo - Visualiza Certidão.pdf',
          last_updated_at: '22/06/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social Via Invest Partners',
          representative: 'Luiz Carlos Casante',
          file: '/pdfs/Jucesp - Junta Comercial do Estado de São Paulo - Visualiza Certidão Partners.pdf',
          last_updated_at: '22/06/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social GGC',
          representative: 'Luiz Carlos Casante',
          file: '/pdfs/contrato-ggc.pdf',
          last_updated_at: '09/01/2026',
          updated_by: 'Karen Ferreira'
        },
        {
          file_name: 'Contrato social Via Fomento',
          representative: 'Luiz Carlos Casante, Wagner Castilho Rodrigues Fernandes',
          file: '/pdfs/contrato-via-fomento.pdf',
          last_updated_at: '09/01/2026',
          updated_by: 'Karen Ferreira'
        },
      ]
    }
  }
}
</script>

<style scoped>
</style>
